import ReviewService from '../../services/ReviewService';
import reviewUseCase from './reviewUseCase';

const reviewFactory = reviewUseCase({ ReviewService: ReviewService() });

export default reviewFactory;
